<template>
  <div class="code-container" :style="codeStyle" >
    <div :id="'qrcode' + Object.values(myid).join('')"></div>
  </div>
</template>

<script>
import { isSsrPage } from "utils/index"
import eventMixin from "utils/event/eventMixin.js"
import QRCode from "qrcodejs2"
import dataRenderMixin from "materials/dataRenderMixin"
export default {
  mixins: [eventMixin, dataRenderMixin],
  name: "cxCode",
  props: {
    type: { type: String },
    options: {
      type: Object,
      default: null
    },
    myid: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      reloadTimer: null,
      componentReset: true,
    }
  },
  watch: {
    "options.width"() {
      this.generateQrcode()
    },
    "options.height"() {
      this.generateQrcode()
    },
    linkUrlVal() {
      this.generateQrcode()
    },
    codeColor() {
      this.generateQrcode()
    },
    bgStyle() {
      this.generateQrcode()
    },
    "options.detailFieldMapping": {
      deep: true,
      handler(n, o) {
        if (n) {
          this.updateData()
        }
      }
    },
    "options.correctLevel"() {
      this.generateQrcode()
    },
  },
  mounted() {
    this.generateQrcode()
    //编辑页不需要运行插件就在插件内部通过isSsrPage来判断环境后，再由插件内部自行决定是否运行
    this.$initPlugin(this.options?.pluginName)
    this.updateData()
    if (this.isBigScreenPreview() && this.options.autoUpdate !== false) {
      this.reloadTimer = setInterval(() => this.updateData(), this.updateTimer)
    }
  },
  destroyed() {
    clearInterval(this.reloadTimer)
    this.reloadTimer = null
  },
  computed: {
    updateTimer() {
      if (!this.options.updateTimer) {
        this.$changeOptionsEV(600, "updateTimer", false, false, false, true)
        return 600 * 1000
      }
      return this.options.updateTimer * 1000
    },
    themeColor() {
      return isSsrPage() ? this.$store.state.page.themeColor : this.$store.state[this.request_prefix].page.themeColor
    },
    // 获取背景颜色
    bgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.background
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("bgColorIsThemeColor") ? this.options.bgColorIsThemeColor : false,
            color: this.options.bgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
          //   let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
          //   containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
          //   containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},${bg.clipSize}`:`${bg.clipSize}`
          //   containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},${bg.alignType}`:`${bg.alignType}`
          //   containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},${bg.repeatType}`:`${bg.repeatType}`
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor
            //   ? this.$store.state[this.request_prefix].page.themeColor
            //   : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            // let tmp = []
            // if (bg.data.stops.length > 0) {
            //   bg.data.stops.forEach(item => {
            //     tmp.push(item[0] + " " + item[1] * 100 + "%")
            //   })
            //   let dot = containerBg.backgroundImage.length > 0 ? "," : ""
            //   containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
            //   containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
            //   containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
            //   containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            // }
            break
          case "radialGradient":
            // let radialTmp = []
            // if (bg.data.stops.length > 0) {
            //   bg.data.stops.forEach(item => {
            //     radialTmp.push(item[0] + " " + item[1] * 100 + "%")
            //   })
            //   let dot = containerBg.backgroundImage.length > 0 ? "," : ""
            //   containerBg.backgroundImage +=
            //     dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
            //   containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
            //   containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
            //   containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            // }
            break
          default:
        }
      })
      return containerBg
    },
    codeColor() {
      let codeColorIsTheme = this.options.hasOwnProperty("codeColorIsTheme") ? this.options.codeColorIsTheme : false
      return this.$parseColor(this.options.codeColor, {
        isThemeColor: codeColorIsTheme
      })
      // return codeColorIsTheme ? this.themeColor : this.options.codeColor?.color
    },
    codeStyle() {
      return {
        opacity: this.options.opacity,
        transform: "rotate(" + this.options.rotate + "deg)",
      }
    },
    linkUrlVal() {
      let value = ""
      console.log('this.options.linkAddressVal :>>',this.options.linkAddressVal);

      if (this.options.linkAddressVal === "默认" && !this.options.linkUrlVal) {
        // 初始化没有设置默认值
        const { pageId } = this.$store.state.states.getDataPageIds
        value = window.location.protocol + '//' + window.location.host + `/v2/p/${pageId}`
      } else {
        value = this.options.linkUrlVal
      }
      return value
    }
  },
  methods: {
    generateQrcode() {
      let id = "qrcode" + Object.values(this.myid).join('')
      let size = Math.min(this.options.width, this.options.height)
      document.getElementById(id).innerHTML = ""
      let correctLevel = this.options && this.options.correctLevel ? QRCode.CorrectLevel[this.options.correctLevel] : QRCode.CorrectLevel.H
      this.qrcode = new QRCode(id, {
        width: size,
        height: size,
        // text: this.options, // 二维码地址
        colorDark: this.codeColor, // 颜色
        colorLight: this.bgStyle.backgroundColor, // 背景色
        text: this.linkUrlVal,
        correctLevel: correctLevel
      })
    },
    async updateData() {
      this.updateNormalRect.call(this, data => {
        console.log("updateCb", data)
        if (typeof data === "string") {
          this.$changeOptionsEV(data, "linkUrlVal", false, null, this.myid, true)
        } else {
          // 如果首页绑定了字段匹配 不能获取第一个值
          if (
            !this.options.currentFiledMapping ||
            (this.options.currentFiledMapping && !this.options.currentFiledMapping.isChecked)
          ) {
            this.$changeOptionsEV(data[0][Object.keys(data[0])[0]].value, "linkUrlVal", false, null, this.myid, true)
          } else if (this.options.currentFiledMapping && this.options.currentFiledMapping.fieldFlag) {
            this.$changeOptionsEV(
              data[0][this.options.currentFiledMapping.fieldFlag].value,
              "linkUrlVal",
              false,
              null,
              this.myid,
              true
            )
          }
        }
      })
    },
  }
}
</script>

<style scoped>
</style>
